export function toBoolean(value: any): boolean {
	return value === "true" || value === true;
}
